import React, { useEffect, useState } from 'react';
import PageLayout from 'components/layouts/PageLayout';
import { InnerSection } from 'components/layouts/CommonForm';
import { InnerGroup } from 'components/layouts/CommonForm';
import { InputField, Row, Select, useModelStateContext } from 'saladsoft-primitive';
import { CountButton } from 'components/input/CountButton';
import Text from 'components/commons/Text';
import { toast } from 'react-toastify';
import {
  AdminListingDto,
  AdminBedTypeDto,
  ListingBedRequestDto,
  AdminListingBedDto,
} from 'services/data-contracts';
import { useStateContext } from 'providers/usePageState';
import Button from 'components/input/Button';
import { saveListing } from 'controllers/listingsController';
import ButtonWrapper from 'components/pages/listings/ButtonWrapper';
import ServiceHelper from 'stores/ServiceHelper';
import { FormControlLabel, Switch } from '@mui/material';
import { Checkbox } from '@mui/material';
import { FormGroup } from '@mui/material';

interface AdminBedTypeModel extends AdminBedTypeDto {
  checked: boolean;
  count: number;
}

const GuestInfoPage = () => {
  const { listing, setListing } = useStateContext();
  const { setState, stateModel, updateServiceModel, setMultipleState, serviceModel } =
    useModelStateContext<AdminListingDto>();

  const generateHourOptions = () => {
    return Array.from(Array(24).keys()).map((i) => ({
      key: i.toString().padStart(2, '0'),
      value: i.toString().padStart(2, '0'),
    }));
  };
  const [bedTypes, setBedTypes] = useState<AdminBedTypeModel[]>([]);
  const [hourOptions] = useState(generateHourOptions());

  const handleSave = async () => {
    if (serviceModel.current) {
      const newListing = (await saveListing(serviceModel.current)) as AdminListingDto;
      setListing(newListing);
    }

    if (bedTypes) {
      const bedTypesToSave: ListingBedRequestDto[] = bedTypes
        .filter((bedType) => bedType.checked)
        .map((bedType) => ({
          id: bedType.id,
          qty: bedType.count,
        }));
      ServiceHelper.adminListingService
        ?.saveBedTypes(listing?.id as number, bedTypesToSave)
        .then((res) => {
          console.log('res', res);
        });
    }
  };

  const mergeBedTypes = (bedTypes: AdminBedTypeModel[]) => {
    if (bedTypes?.length > 0) {
      /** 리스팅에 속한 침대타입 조회 */
      ServiceHelper.adminListingService
        ?.getBedTypesByListing1(listing?.id as number)
        .then((res) => {
          const updatedBedTypes = bedTypes.map((bedType: AdminBedTypeModel) => {
            const listingBedType = res.data.find((b) => b.bedTypeId === bedType.id);
            return {
              ...bedType,
              checked: listingBedType?.qty && listingBedType?.qty > 0 ? true : false,
              count: listingBedType?.qty || 0,
            };
          });

          setBedTypes(updatedBedTypes as AdminBedTypeModel[]);
        });
    }
  };

  useEffect(() => {
    if (listing) {
      setMultipleState(listing);

      /** 모든 침대타입 조회회 */
      ServiceHelper.adminBedTypeService?.getBedTypes().then((res) => {
        // setBedTypes(res.data as AdminBedTypeModel[]);
        mergeBedTypes(res.data as AdminBedTypeModel[]);
      });
    }
  }, [listing]);

  return (
    <PageLayout title="게스트 및 시설정보">
      <InnerSection>
        <Row flexDirection="column" gap={66} alignItems="flex-start">
          <InnerGroup>
            <div>
              <Text type="H3" style={{ marginBottom: 10 }}>
                인원수 설정
              </Text>
              <Text type="H4" buttonRole="DESCRIPTION">
                시설의 위치를 선택 해 주세요. <br />
                단일선택만 가능합니다.
              </Text>
            </div>
            <div>
              <Row flexDirection="column" alignItems="flex-start" gap={10}>
                <Text type="H4" style={{ fontWeight: 500 }}>
                  최소 인원 수
                </Text>
                <CountButton
                  count={
                    stateModel?.maxGuest &&
                      stateModel?.minGuest &&
                      stateModel.maxGuest < stateModel.minGuest
                      ? stateModel?.maxGuest
                      : stateModel?.minGuest || 2
                  }
                  maxCount={stateModel?.maxGuest || 10}
                  onChange={(count: number) => {
                    if (count > (serviceModel.current?.maxGuest || 0)) {
                      toast.warning('최대 인원보다 클 수 없습니다.');
                      return;
                    }
                    setState('minGuest', count);
                  }}
                />
              </Row>
              <Row flexDirection="column" alignItems="flex-start" marginTop={30} gap={10}>
                <Text type="H4" style={{ fontWeight: 500 }}>
                  입실가능한 최대 인원 수
                </Text>
                <CountButton
                  count={stateModel?.maxGuest || 10}
                  maxCount={10}
                  onChange={(count: number) => {
                    setState('maxGuest', count);
                  }}
                />
              </Row>
            </div>
          </InnerGroup>
          <InnerGroup>
            <div>
              <Text type="H3" style={{ marginBottom: 10 }}>
                시설정보 설정
              </Text>
              <Text type="H4" buttonRole="DESCRIPTION">
                시설의 크기 및 주차가능여부등의 <br />
                정보를 입력 해주세요.
              </Text>
            </div>
            <Row
              gap={10}
              flexDirection="column"
              alignItems="flex-start"
              justifyContent="flex-start"
            >
              <Row justifyItems="flex-start" alignItems="flex-start" gap={20}>
                <div>
                  <Text type="H4" style={{ fontWeight: 500, marginBottom: 10 }}>
                    시설의 크기(㎡)
                  </Text>
                  <>
                    <InputField
                      style={{ width: 100 }}
                      value={stateModel?.size ?? 0}
                      type="number"
                      onChange={(value) => setState('size', Number(value))}
                    />
                  </>
                </div>
                <div>
                  <Text type="H4" style={{ fontWeight: 500, marginBottom: 10 }}>
                    침실갯수
                  </Text>
                  <>
                    {typeof listing?.bedroomsNumber !== 'undefined' && (
                      <InputField
                        style={{ width: 100 }}
                        defaultValue={listing?.bedroomsNumber ?? 0}
                        type="number"
                        onChange={(value) => updateServiceModel('bedroomsNumber', Number(value))}
                      />
                    )}
                  </>
                </div>
                <div>
                  <Text type="H4" style={{ fontWeight: 500, marginBottom: 10 }}>
                    욕실 갯수
                  </Text>
                  <>
                    {typeof listing?.bathroomsNumber !== 'undefined' && (
                      <InputField
                        style={{ width: 100 }}
                        defaultValue={listing?.bathroomsNumber ?? 0}
                        type="number"
                        onChange={(value) => {
                          updateServiceModel('bathroomsNumber', Number(value));
                        }}
                      />
                    )}
                  </>
                </div>
              </Row>
              <>
                {typeof listing?.hasParking !== 'undefined' && (
                  <Row flexDirection="column" alignItems="flex-start" marginTop={30} gap={10}>
                    <Text type="H4" style={{ fontWeight: 500 }}>
                      주차가능여부
                    </Text>

                    <FormControlLabel
                      control={
                        <Switch
                          size="medium"
                          defaultChecked={listing?.hasParking}
                          onChange={(e) => setState('hasParking', e.target.checked)}
                        />
                      }
                      label=""
                    />
                  </Row>
                )}
              </>
              <div style={{ marginTop: 30 }}>
                <Text type="H4" style={{ fontWeight: 500, paddingBottom: 15 }}>
                  체크인/체크아웃 시간
                </Text>
                <Row gap={10} marginBottom={10} justifyContent="flex-start">
                  <Select
                    itemBoxStyle={{ height: 200, overflow: 'auto' }}
                    fullWidth={true}
                    style={{ minWidth: 250 }}
                    containerStyle={{}}
                    defaultKey={'15'}
                    placeHolder="체크인 시간선택"
                    items={hourOptions}
                    onChange={(value: Record<string, any>) => {
                      updateServiceModel('checkInTime', value.value);
                      // setCheckinHour(value.value);
                    }}
                    useRound={false}
                  />

                  <Select
                    placeHolder="체크아웃 시간선택"
                    itemBoxStyle={{ height: 200, overflow: 'auto' }}
                    style={{ minWidth: 250 }}
                    defaultKey={'11'}
                    items={hourOptions}
                    onChange={(value: Record<string, any>) => {
                      updateServiceModel('checkOutTime', value.value);
                      // setCheckoutHour(value.value);
                    }}
                    useRound={false}
                  />
                </Row>
              </div>
            </Row>
          </InnerGroup>
          <InnerGroup>
            <div>
              <Text type="H3" style={{ marginBottom: 10 }}>
                침대 설정
              </Text>
              <Text type="H4" buttonRole="DESCRIPTION">
                시설의 위치를 선택 해 주세요. <br />
                단일선택만 가능합니다.
              </Text>
            </div>
            <div>
              <Row flexDirection="column" alignItems="flex-start" gap={10}>
                <Text type="H4" style={{ fontWeight: 500 }}>
                  침대 타입
                </Text>
                <>
                  {bedTypes?.map((bedType) => (
                    <>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={bedType.checked}
                              onChange={(e) => {
                                const newBedTypes = [...bedTypes];
                                const updatedBedType = newBedTypes.find((b) => b.id === bedType.id);
                                if (updatedBedType) {
                                  updatedBedType.checked = e.target.checked;
                                  updatedBedType.count = 1;
                                }
                                setBedTypes(newBedTypes);
                              }}
                            />
                          }
                          label={bedType.localizedName?.ko}
                        />
                      </FormGroup>
                      {bedType.checked === true && (
                        <>
                          <CountButton
                            count={bedType.count || 1}
                            maxCount={5}
                            onChange={(count: number) => {
                              const newBedTypes = [...bedTypes];
                              const updatedBedType = newBedTypes.find((b) => b.id === bedType.id);
                              if (updatedBedType) {
                                updatedBedType.count = count;
                              }
                              setBedTypes(newBedTypes);
                            }}
                          />
                        </>
                      )}
                    </>
                  ))}
                </>
              </Row>
            </div>
          </InnerGroup>
          <ButtonWrapper>
            <Button style={{ minHeight: 25, width: 100 }} onClick={handleSave}>
              저장
            </Button>
          </ButtonWrapper>
        </Row>
      </InnerSection>
    </PageLayout>
  );
};

export default GuestInfoPage;
